import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterOutlet } from '@angular/router';

import { Subject, takeUntil } from 'rxjs';

import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';

import { AuthService } from 'app/core/auth/auth.service';
import { UserProfile } from 'app/core/auth/auth.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserComponent } from 'app/layout/common/user/user.component';
import { GlobalQrNavigatorDialogComponent } from 'app/modules/global-qr-navigator-dialog/global-qr-navigator-dialog.component';
import { GlobalFilterComponent } from 'app/shared/components/global-filter/global-filter.component';

@Component({
  selector: 'classy-layout',
  templateUrl: './classy.component.html',
  styleUrl: './classy.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    FuseLoadingBarComponent,
    FuseVerticalNavigationComponent,
    UserComponent,
    MatIconModule,
    MatButtonModule,
    FuseFullscreenComponent,
    RouterOutlet,
    CdkScrollableModule,
    GlobalFilterComponent,
  ],
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  navigation: Navigation;
  user: UserProfile;
  private unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
    private fuseMediaWatcherService: FuseMediaWatcherService,
    private fuseNavigationService: FuseNavigationService,
    private router: Router,
    private dialog: MatDialog,
  ) {}

  get currentYear(): number {
    return new Date().getFullYear();
  }

  ngOnInit(): void {
    // Subscribe to navigation data
    this.navigationService.navigation$.pipe(takeUntil(this.unsubscribeAll)).subscribe((navigation: Navigation) => {
      this.navigation = navigation;
    });

    // Subscribe to the user profile
    this.authService.userProfile$.pipe(takeUntil(this.unsubscribeAll)).subscribe((profile: UserProfile) => {
      this.user = profile;
    });

    // Subscribe to media changes
    this.fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation = this.fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }

  logOut(): void {
    this.router.navigate(['/auth/logout']);
  }

  launchGlobalQrScanner() {
    this.dialog.open(GlobalQrNavigatorDialogComponent, { maxWidth: '800px', minHeight: '400px' });
  }
}
